import React from 'react';
import {useSelector} from 'react-redux';
import {get, noop} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE} from '/enum/reportCard.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import {TIER_NAMES} from '../EligibleClientSupportBonusPlusReport/CoachesAcquiringClients';
import withRecordPopover from '../withRecordPopover';

import reportPayload from './reportPayload';
import {SevenToNineCSBPContent} from './SevenToNineCSBPContent';
type LoadingDataType = {
  total?: number;
};
type SevenToNineCSBPReportProps = {
  showRecordPopover: () => void;
  loadingData: LoadingDataType;
};
export const SevenToNineCSBPReport: React.FC<SevenToNineCSBPReportProps> = ({
  loadingData = {},
  showRecordPopover = noop,
}) => {
  const featureFlag = useSelector(variablesFeatureFlag);
  const showEnhancedCSBPlus = get(featureFlag, 'showEnhancedCSBPlus', false);
  const showCsbPlusInsightsFiltering = shouldReleaseFeature(
    get(featureFlag, 'ff_csb_plus_insights_filtering', ''),
  );
  const {tt} = useTranslation('report.eligibleClientSupportBonusPlusReport');
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt(
        'title',
        showEnhancedCSBPlus || showCsbPlusInsightsFiltering
          ? 'Client Support Bonus+'
          : 'Eligible for Client Support Bonus+',
      )}
      description={tt(
        'description',
        showCsbPlusInsightsFiltering
          ? 'These are your coaches who have qualified for the Client Support Bonus+. Encourage them to sign up 3 new clients to earn a 3% bonus! After welcoming 3 new clients, additional new clients will help them increase their bonus to 5%, 7% or 10%!'
          : showEnhancedCSBPlus
          ? 'These are your coaches currently eligible for the Client Support Bonus+ Encourage them to sign up 2 new clients to earn a 3% bonus! After welcoming 2 new clients, both new and reactivated clients will help them increase their bonus to 5% or 7%!'
          : 'These Coaches are currently eligible for a Client Support Bonus+. Help encourage them to sign up new Clients this month to get it!',
      )}
      isCSBReport={true}
      tierName={TIER_NAMES.SEVEN_NINE}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={SevenToNineCSBPContent}
    />
  );
};
export const SevenToNineCSBPReportWithRecordPopover = withRecordPopover({
  reportPayload,
  popoverName: COACH_REPORT,
  popoverContentName: REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE,
  popoverContentProps: {},
})(SevenToNineCSBPReport);
